import moment from "moment";
import { ProduktspecifikationDTO } from "~app/common/models/produkt/ProduktDTO";
import { DateUtils } from "~app/common/utils/date-utils";
import { ObjectUtils } from "~app/common/utils/object-utils";
import { ValidationErrorLevels } from "~app/common/validation/ValidationErrorLevels";
import { ValidationScopes } from "~app/common/validation/ValidationScopes";
import { ValidationContext } from "~app/common/validation/validationContext";
import { ProduktDetailTexts } from "../produkt-detail.texts";

export class ProduktDetailProduktspecifikationValidation {
    static init(produktspecifikation: ProduktspecifikationDTO): ValidationContext {
        const isValidDate = (val: any): boolean => (
            moment(val, DateUtils.dateformat, true).isValid() ||
                moment(
                    (val as string).substring(0, 10),
                    DateUtils.dateformat,
                    true
                ).isValid()
        );

        const context = new ValidationContext();
        context.errorLevel = ValidationErrorLevels.error;
        context.create(ValidationScopes.spara).withRules([
            {
                errorLevel: ValidationErrorLevels.error,
                expression: (newVal) => {
                    if (!newVal) {
                        return false;
                    }

                    if (!isValidDate(newVal)) {
                        return false;
                    }

                    if (ObjectUtils.isNullOrUndefined(produktspecifikation.giltigTom)) {
                        return true;
                    }

                    return moment(newVal).isSameOrBefore(moment(produktspecifikation.giltigTom));
                },
                message: { text: ProduktDetailTexts.validation.giltigFrom },
                model: () => produktspecifikation.giltigFrom,
                name: "giltigFrom",
                required: true,
                subscriptions: ["giltigTom"],
                publish: true,
                verbose: true
            },
            {
                applicable: () => !ObjectUtils.isNullOrUndefined(produktspecifikation.giltigFrom),
                errorLevel: ValidationErrorLevels.error,
                expression: (newVal) => {
                    if (!newVal) {
                        return true;
                    }

                    if (!isValidDate(newVal)) {
                        return false;
                    }

                    if (ObjectUtils.isNullOrUndefined(produktspecifikation.giltigFrom)) {
                        return true;
                    }

                    return moment(newVal).isSameOrAfter(moment(produktspecifikation.giltigFrom));
                },
                message: { text: ProduktDetailTexts.validation.giltigTom },
                model: () => produktspecifikation.giltigTom,
                name: "giltigTom",
                subscriptions: ["giltigFrom"],
                publish: true,
                verbose: true
            }
        ]);

        return context;
    }
}
